const Footer = () => {
  return (
    <div className="footer">
      <div className="copyright">
        <p>
          Copyright © Designed &amp; Developed by{" "}
          <a
            href="https://topgrowthnetwork.com"
            target="_blank"
            rel="noreferrer"
          >
            Top Growth Network
          </a>{" "}
          {new Date().getFullYear()}
        </p>
      </div>
    </div>
  );
};

export default Footer;
